var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6841_27742)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1245 10.9945C20.1246 11.2375 19.9277 11.4346 19.6847 11.4347L10.9764 11.4393C10.7334 11.4394 10.5363 11.2425 10.5361 10.9995C10.536 10.7565 10.7329 10.5594 10.9759 10.5593L19.6842 10.5547C19.9272 10.5546 20.1243 10.7515 20.1245 10.9945Z",
    fill: "#08081B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2987 7.61526C16.4705 7.4434 16.7491 7.44334 16.921 7.61514L19.9953 10.6883C20.0778 10.7708 20.1242 10.8827 20.1242 10.9994C20.1242 11.1161 20.0778 11.2281 19.9953 11.3106L16.921 14.3849C16.7492 14.5567 16.4706 14.5567 16.2988 14.3849C16.127 14.213 16.127 13.9344 16.2988 13.7626L19.0619 10.9995L16.2989 8.23751C16.127 8.06571 16.1269 7.78712 16.2987 7.61526Z",
    fill: "#08081B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.26741 2.51741C5.69374 2.09107 6.27197 1.85156 6.8749 1.85156H17.3982V5.94792C17.3982 6.19092 17.2012 6.38792 16.9582 6.38792C16.7152 6.38792 16.5182 6.19092 16.5182 5.94792V2.73156H6.8749C6.50536 2.73156 6.15096 2.87836 5.88966 3.13966C5.62836 3.40096 5.48156 3.75536 5.48156 4.1249V17.8749C5.48156 18.2444 5.62836 18.5988 5.88966 18.8601C6.15096 19.1214 6.50536 19.2682 6.8749 19.2682H15.1249C15.4944 19.2682 15.8488 19.1214 16.1101 18.8601C16.3714 18.5988 16.5182 18.2444 16.5182 17.8749V16.0416C16.5182 15.7986 16.7152 15.6016 16.9582 15.6016C17.2012 15.6016 17.3982 15.7986 17.3982 16.0416V17.8749C17.3982 18.4778 17.1587 19.0561 16.7324 19.4824C16.3061 19.9087 15.7278 20.1482 15.1249 20.1482H6.8749C6.27197 20.1482 5.69374 19.9087 5.26741 19.4824C4.84107 19.0561 4.60156 18.4778 4.60156 17.8749V4.1249C4.60156 3.52197 4.84107 2.94374 5.26741 2.51741Z",
    fill: "#08081B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6841_27742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutSvg);
export default __webpack_public_path__ + "static/media/LogoutSvg.b9a957934efa27e641aae8b165e10430.svg";
export { ForwardRef as ReactComponent };